import React from "react";
import PropTypes from 'prop-types';
import cx from "classnames";

import { 
  SentimentList, 
  sentiments, 
} from "./SentimentList";

import "./ProsCons.scss";

export const ProsCons = props => {
  const className = cx("pros-cons", props.className);

  return (
    <div className={className}>
      <h3 className="pros-cons__heading">
        {props.prosConsHeading}
      </h3>
      <div className="pros-cons__content">
        <SentimentList reviews={props.pros} sentiment={sentiments.positive} />  
        <SentimentList reviews={props.cons} sentiment={sentiments.negative} />     
      </div>
    </div>
  );
};

ProsCons.propTypes = {
  heading: PropTypes.string.isRequired,
  pros: PropTypes.arrayOf(String).isRequired,
  cons: PropTypes.arrayOf(String).isRequired,
};
